<div class="reset-content">
  <hyperkit-typography variant="h1" color="primary" align="center"
    >Reset Password</hyperkit-typography
  >
  <hyperkit-typography variant="body" size="sm" color="secondary"
    >{{ passRequirements }}
  </hyperkit-typography>

  @if (!formSubmitted) {
    <form [formGroup]="form" (ngSubmit)="submitForm()">
      <div class="form-group">
        <hyperkit-input
          class="hyperkit-component"
          type="password"
          id="password"
          label="New Password"
          placeholder="New Password"
          formControlName="password"
          [pattern]="passRegex"
        ></hyperkit-input>
      </div>
      <div class="form-group">
        <hyperkit-input
          class="hyperkit-component"
          type="password"
          label="Confirm Password"
          placeholder="Confirm Password"
          formControlName="confirmPassword"
        ></hyperkit-input>
        @if (
          form.controls.confirmPassword.touched &&
          form.controls.confirmPassword.dirty &&
          form.controls.password.value !==
            form.controls.confirmPassword.value &&
          form.controls.confirmPassword.value.length > 0
        ) {
          <hyperkit-error
            class="form-error"
            [error]="'Passwords do not match.'"
          ></hyperkit-error>
        }
      </div>
      <div class="options">
        <hyperkit-button
          type="submit"
          size="medium"
          routerLink="/"
          [fullWidth]="true"
          color="secondary"
          text="Cancel"
        ></hyperkit-button>
        <hyperkit-button
          type="submit"
          class="sign-in-button"
          size="medium"
          [disabled]="!form.valid"
          [fullWidth]="true"
          color="tertiary"
          text="Change Password"
        ></hyperkit-button>
      </div>
    </form>
  }

  @if (formSubmitted) {
    <hyperkit-typography variant="body" size="md" color="primary"
      >Your password has been reset successfully.
    </hyperkit-typography>
    <hyperkit-button
      class="sign-in-button"
      routerLink="/"
      size="medium"
      [fullWidth]="true"
      color="tertiary"
      text="Return to Login"
    ></hyperkit-button>
  }
</div>
